import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
} from '@angular/core';
import { Option } from '../../models/theme-option.model';

@Component({
  selector: 'app-myThemesDropdown',
  templateUrl: './myThemesDropdown.component.html',
  styleUrls: ['./myThemesDropdown.component.scss'],
})
export class MyThemesDropdownComponent implements OnChanges {
  @Input() theme: Option;
  @Input() options: Array<Option>;
  @Output() themeChange: EventEmitter<Option> = new EventEmitter<Option>();

  ngOnChanges() {
    console.log(this.theme.id);
  }

  changeTheme() {
    this.themeChange.emit(this.theme);
  }
}
